<template>
  <div>
    <ModalBase title="Update Note"
               @close-modal="closeModal"
               @proceed="updateNote"
               ctaProceed="Update">

      <div class="ingredients">
        <form>
          <div class="form-group col">
            <label for="brew-session-note-date">Date</label>
            <input v-model="noteDate" class="form-control" type="date" id="brew-session-note-date">
            <div class="invalid-feedback">{{errorFields['Note_date']}}</div>
          </div>
          <div class="form-group col">
            <label for="brew-session-note">Note</label>
            <textarea v-model="noteContent"
                      class="form-control"
                      v-bind:class="{ 'is-invalid': errorFields['Note_content'] }"
                      id="brew-session-note"></textarea>
            <div class="invalid-feedback">{{errorFields['Note_content']}}</div>
          </div>
        </form>
      </div>
    </ModalBase>
  </div>

</template>

<script>
    import ModalBase from "./ModalBase";
    import { HTTP } from '../../lib/http';

    export default {
        name: "notes-modal",
        props: {
            note: Object,
            brewSessionId: Number
        },
        components: {
            ModalBase,
        },
        data() {
            return {
                errors: null,
                errorFields: {},
                noteContent: null,
                noteDate: null
            };
        },
        methods: {
            closeModal() { this.$emit('close-modal', true); },

            updateNote() {
                this.errors = [];
                this.errorFields = {};

                HTTP.patch(`brew-sessions/${this.brewSessionId}/notes/${this.note.id}`, { data: {
                        content: this.noteContent,
                        created_at: this.noteDate
                    }
                })
                    .then(response => {
                        this.closeModal()
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                        _(this.errors[0]).each((errorItem) => {
                            this.errorFields[errorItem.field.replace('.', '_')] = errorItem.detail;
                        })
                    })
            },
        },
        beforeMount() {
            this.noteContent = this.note.content;
            this.noteDate = this.note.date;
        },
    };
</script>

<style scoped lang="scss">
</style>
